module.exports = __webpack_public_path__ + "static/media/lvguan.a37b1445.gif";